import { ChevronDown } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, FadeIn, GoldButton } from "./Reveal";

const FAQS = [
  {
    q: "Do you have to be staying at the Lodge to do the adventure activities?",
    a: "Yes, of course. The Adventure Islands is open to the general public 365 days a year, from 9am to 6pm, for adventure activities like Sea Safari, stand-up paddleboarding, kayaking, sumo wrestling, bush skills, sauna and our new beach sauna. We take you from Rosmoney Pier to Collanmore Island by high-speed boat, and all the prices are outlined on the website for each individual activity. The prices include the high-speed return ferry to the island.",
  },
  {
    q: "How long is the kayaking session?",
    a: "Sit-on-top kayaking takes 2 hours, including the high-speed RIB trip to the island.",
  },
  {
    q: "Can I choose activities when I arrive?",
    a: "Depending on the weather \u2014 if you're booked in for sea kayaking and the winds are light, you can also try stand-up paddleboarding.",
  },
  {
    q: "Can I add extra activities to my package?",
    a: "Yes you can. Just let us know as soon as you can and we will try to accommodate all your requests.",
  },
  {
    q: "At what age can children take part?",
    a: "We run adventure activities for all ages from 8 years and up.",
  },
  {
    q: "What do I need to bring?",
    a: "The main items to bring are a swimsuit and a towel \u2014 we provide all the equipment and gear.",
  },
  {
    q: "What if it's raining?",
    a: "The rain will not affect our water activities \u2014 you're going to get wet anyway!",
  },
  {
    q: "What if I can't swim?",
    a: "There is no need to know how to swim, as you will always be wearing a flotation device.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-navy-900 py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-16 px-5 sm:px-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <Eyebrow>FAQ</Eyebrow>
          <FadeIn delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ivory sm:text-5xl">
              Here's all you <em className="italic text-gold">need to know</em>
            </h2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="mt-8 max-w-sm text-sm font-light leading-relaxed text-mist sm:text-base">
              Everything about your day on the island. Anything else, call us on{" "}
              <a href="tel:+353862518252" className="text-gold transition-colors hover:text-gold-light">
                +353 86 251 8252
              </a>{" "}
              or send an enquiry.
            </p>
          </FadeIn>
          <FadeIn delay={0.3}>
            <GoldButton href="#contact" testId="faq-cta" className="mt-10">
              Get In Touch
            </GoldButton>
          </FadeIn>
        </div>

        <FadeIn delay={0.15} className="lg:col-span-3">
          <Accordion type="single" collapsible className="border-t border-white/10">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="group border-b border-white/10">
                <AccordionTrigger
                  data-testid={`faq-item-${i + 1}`}
                  className="py-6 text-left font-serif text-xl font-medium text-ivory transition-colors hover:text-gold hover:no-underline sm:text-2xl [&>svg]:hidden"
                >
                  <span className="flex items-center justify-between gap-6 pr-2">
                    {f.q}
                    <ChevronDown className="h-4 w-4 shrink-0 text-gold transition-transform duration-300 group-data-[state=open]:rotate-180" />
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm font-light leading-relaxed text-mist">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeIn>
      </div>
    </section>
  );
}
